/**
 * SearchBar component for product search input.
 *
 * Renders a full-width search input with a magnifying glass icon.
 * Designed to sit at the top of the product browsing panel.
 *
 * @param {Object}   props
 * @param {string}   props.value       - Current search value.
 * @param {Function} props.onChange     - Callback fired on input change; receives the event.
 * @param {string}   [props.placeholder='Search products...'] - Input placeholder text.
 */
import { createElement } from 'react';

export default function SearchBar({
  value,
  onChange,
  placeholder = 'Search products...',
}) {
  return (
    <div className="relative w-full">
      {/* Magnifying glass icon */}
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <svg
          className="h-5 w-5 text-gray-400"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </div>

      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={
          'block w-full rounded-lg border border-gray-300 bg-white py-2.5 pl-10 pr-4 ' +
          'text-sm text-gray-900 placeholder-gray-400 ' +
          'outline-none transition-shadow ' +
          'focus:border-pos-primary focus:ring-2 focus:ring-pos-primary/20'
        }
        aria-label={placeholder}
      />

      {/* Clear button shown when value is non-empty */}
      {value && (
        <button
          type="button"
          onClick={() => onChange({ target: { value: '' } })}
          className={
            'absolute inset-y-0 right-0 flex items-center pr-3 ' +
            'text-gray-400 hover:text-gray-600'
          }
          aria-label="Clear search"
        >
          <svg
            className="h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  );
}
